import React, { useContext } from "react";
import './benefits.css';
import { benefits, benefitsEn } from "../../json/benefits";
import { LanguageContext } from "../../context/LanguageContext/LanguageContext";
// import { Parallax } from 'react-scroll-parallax';

const Benefits = () => {
    const { language } = useContext(LanguageContext);
    const data = language === 'ES' ? benefits : benefitsEn;

    return (
        // <Parallax speed={-10}>
            <div className="benefits-container">
                <div className="benefits-header text-center">
                    <span>{data.mainTitle}</span>
                    <h1>{data.mainSubTitle}</h1>
                </div>
                <div className="container">
                    <div className="benefits-list row">
                        {data.items.map((benefit, index) => (
                            <div key={index} className="benefit-item col-md-6">
                                <div className="benefit-title">
                                    {benefit.title}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        // </Parallax>
    );
};

export default Benefits;
